export default {
    conditionImport: 'Import File Conditions',
    firstImportCondition: 'Create employee list before uploading facial image.',
    secondImportCondition: 'File must be in Zip format with image .jpg and named the image by Employee ID e.g. 12345',
    thirdImportCondition: 'Please verify that the information in Zip file is correct before upload.',
    shouldBeZip: 'File should be .Zip',
    importResult: 'Import Result'
}
